import { ResetPasswordOTP, WelcomeAuth } from '../../components/auth';
import { SafeAreaView, StyleSheet } from 'react-native';

import { KeyboardAvoidingView } from '../../components/shared';
import { Layout } from '@ui-kitten/components';
import React from 'react';
import { RootStackScreenProps } from 'src/core';
import { authStyles } from './_authStyles';
import { resetPasswordOTPScreen } from 'src/core/brands';
import { useGetAppName } from 'src/core/hooks/useBrands';
import { useTranslationFunc } from 'src/core/hooks/useTranslationFunc';

const ResetPasswordOTPScreen = ({ route, navigation }: RootStackScreenProps<'PasswordOTP'>) => {
  const t = useTranslationFunc(resetPasswordOTPScreen);
  const appName = useGetAppName();

  // styles
  const styleContainer = StyleSheet.create({
    screenContainer: { flex: 1 },
    safeAreaView: { flex: 1 }
  });

  // handlers and conditionals
  const resetActionClickHandler = () => navigation.navigate('ConfirmationReset');

  // view
  return (
    <KeyboardAvoidingView extraHeight={200} keyboardOpeningTime={0} scrollEnabled={false}>
      <Layout level="2" style={[authStyles.authScreenContainer, styleContainer.screenContainer]}>
        <SafeAreaView style={styleContainer.safeAreaView}>
          <WelcomeAuth title={t('welcomeTitle')} welcomeCaption={t('welcomeCaption', { app_name: appName })} />
          <ResetPasswordOTP resetActionClickHandler={resetActionClickHandler} email={(route.params as any).email} />
        </SafeAreaView>
      </Layout>
    </KeyboardAvoidingView>
  );
};

export default ResetPasswordOTPScreen;
